<div class="c-banner" [ngClass]="customClass">
  <div class="c-banner__main">
    <div class="c-banner__left">
      <div class="c-banner__text">
        <div class="c-banner__title">{{ banner.title }}</div>
        <div class="c-banner__subtitle">{{ banner.subtitle }}</div>
      </div>
      <div class="c-banner__buttons">
        <a *ngFor="let button of banner.buttons" p500-ui-button [routerLink]="button.link" target="_blank">
          {{ button.label }}
        </a>
      </div>
    </div>
    <div class="c-banner__right" [ngStyle]="{ 'background-image': 'url(' + banner.img + ')' }"></div>
  </div>
  <div class="c-banner__close-button">
    <p500-ui-icon (click)="onClose.emit()" class="pointer" name="close" size="16px" className="text-color--primary"></p500-ui-icon>
  </div>
</div>
